<template>
  <section>
    <div :style="{borderColor: $store.getters.clientStyle.primary, opacity: doesNotApply ? .3 : 1}"
      class="global-question-card container global-question-card-padding"
      @mouseover="comment.questionIsFocussed=true"
      @mouseleave="() => {if (questionData.comment==1) this.$refs.commentBox.leaveComment()}">

      <!-- Component for question title, description, number and required indicator -->
      <question-header />

      <!-- Specific markup for this scale-question for when the description texts are too long to be shown by the default scale slider component -->
      <div class="columns global-answer-padding">

        <div class="column is-full">

          <div v-if="questionData.question_type == 'select_rating_text'">
            <div
              v-for="(value, index) in questionData.values"
              :key="index"
              class="field">
              <!-- {{value.status}} -->
              <div v-if="value.status == true">
                <p-radio class="p-default p-round p-fill p-smooth p-bigger is-size-5 radio-option" :name="'radio'+number" :value="value.rating" v-model="questionData.answer" @change="saveAnswer"></p-radio>

                <!-- <p class="is-size-4 has-text-weight-bold value-rating"> {{ value.rating }}</p> -->
                <p class="is-size-5 radio-option long-value"><span class="is-size-4 has-text-weight-bold value-rating">{{value.rating}}</span> {{ value.text }}</p>

              </div>
            </div>
          </div>

        <!-- markup for this radio-question  -->

          <div v-else>
            <div
            v-for="(value, index) in questionData.values"
            :key="index"
            class="field">

              <p-radio class="p-default p-round p-fill p-smooth p-bigger is-size-5 radio-option" :name="'radio'+number" :value="value" v-model="answer" @change="saveAnswer(value)"></p-radio>

              <p class="is-size-5 radio-option long-value" @click="saveAnswer(value)">{{ value }}</p>

            </div>
          </div>
        </div>

        <!-- button area (right side of question card) -->
        <question-options />

      </div>

      <div v-if="(questionData.isDoesNotApply === '1' || questionData.isDoesNotApply === 1) && (questionData.question_type == 'select_rating' || questionData.question_type == 'select_rating_text')"
        style="padding: 20px 0 0 0">
        <p-check class="p-default p-curve p-fill p-smooth p-bigger is-size-5 p-icon" v-model="doesNotApply" @change="toggleDoesNotApply"><i class="icon fas fa-check check-icon" slot="extra"></i></p-check>
        <div style="margin: 10px 0 0 0; color:#9c9c9c">
          <p class="is-size-5 long-value" style="cursor: default">niet van toepassing</p>
        </div>
      </div>
    </div>

    <!-- Comment component to be redered when comments are allowed for this question -->
    <comment-box ref="commentBox" v-if="questionData.comment=='1'" />
  </section>
</template>

<script>
import QuestionHeader from './QuestionHeader'
import QuestionOptions from './QuestionOptions'
import CommentBox from './CommentBox'

export default {
  components: {
    'question-header': QuestionHeader,
    'question-options': QuestionOptions,
    'comment-box': CommentBox
  },
  props: {
    questionData: Object, // eslint-disable-line vue/require-default-prop
    number: Number // eslint-disable-line vue/require-default-prop
  },
  data () {
    return {
      radio: 'default',
      answer: this.questionData.answer || null,
      uploads: [],
      comment: {
        showComment: false,
        commentFocussed: false,
        questionIsFocussed: false
      },
      doesNotApply: false
    }
  },
  methods: {
    toggleDoesNotApply(event) {
      this.doesNotApply = event;
      this.comment.showComment = true;
      this.questionData.answer = undefined;
      this.questionData.doesNotApply = event;
    },
    saveAnswer (value) {
      if (value) {
        this.answer = value
        this.questionData.answer = value
      }
      this.$store.commit('updateActivity', this.$store.getters.getActivities)
      // console.log(JSON.parse(localStorage.getItem('activities')))
    },
    unselect (value) {
      // console.log(value)
    },
    checkValueLength (value, check, length) {
      // console.log(value)

      if (value && ((check === 'longer' && value.length > length) || (check === 'shorter' && value.length <= length))) {
        return value
      } else {
        return ''
      }
    }
  },
  provide () {
    return {
      question: this.questionData,
      number: this.number,
      comment: this.comment,
      uploads: this.uploads
    }
  }
}
</script>

<style scoped>

.radio-option {
  margin-bottom: 15px;
}

.value-text {
  margin-left: 44px;
}

.value-rating {
  margin-top: -2px;
  margin-left: 3px;
  color: #969696;
  margin-right: 7px;
}

</style>



// WEBPACK FOOTER //
// src/components/elements/RadioQuestion.vue